"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const qrcode_react_1 = __importDefault(require("qrcode.react"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../../common/decorators/withStore"));
const helpers_1 = require("../../../../common/helpers/helpers");
const services_1 = require("../../../../common/services");
const useUrlParams_1 = require("../../../hooks/useUrlParams");
const BookingStatus_1 = __importDefault(require("../../Other/BookingStatus"));
const DetailPageContainer = styled_components_1.default.div `
  z-index: 2;
  display: flex;
  align-items: flex-end;
  padding: 0 5vmin 11vmin;
  height: 100%;
  color: #fff;
  background-color: ${props => props.theme.palette.mainAppColor.main};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: ${(props) => `url(${props.backgroundImages.portrait} )`};

  &.hide {
    visibility: hidden;
  }

  &.detail-page-container {
    animation-duration: ${(props) => props.fadeInContentAnimation * 1}s;

    &-with-logo {
      justify-content: space-between;
      flex-direction: column;
      align-items: center;

      .detail-page-logo {
        z-index: 2;
        margin-top: 4.7vmin;
        height: 6vmin;
      }
    }
  }

  &.hide-app-downloads .download-app-images {
    visibility: hidden;
  }

  @media (orientation: landscape) {
    background-image: ${props => `url(${props.backgroundImages.landscape} )`};
  }
`;
const RegularPageContainer = styled_components_1.default.div `
  width: 100%;

  @media (orientation: landscape) {
    display: flex;
  }

  .texts {
    width: 100%;
    position: relative;

    transform: translate3d(0, ${(props) => props.contentRefHeight}px, 0);
    transition: transform ${(props) => props.enterContentAnimation * 1}s ease-in-out 0s; /* only transition top property */

    &.instant-transition {
      transition: transform 0s ease-in-out 0s;
    }

    &.top-animation {
      transform: translate3d(0, 0vmin, 0);
      .used-for-display {
        visibility: visible;
      }
    }

    .used-for-display {
      animation-delay: ${(props) => props.enterTitleAnimation * 1}s;
      animation-duration: ${(props) => props.enterContentAnimation * 1.2}s;
    }

    .is-hiding {
      animation-delay: 0s;
      animation-duration: ${(props) => props.hideContentAnimation * 1}s;
    }

    // carefull with the title delays and durations, changes lead to crazy behaviours
    .detail-page {
      &-title {
        font-size: 6vmin;
        font-weight: bold;
        padding-bottom: 1.3vmin;

        animation-delay: 0s;
        animation-duration: ${(props) => props.enterTitleAnimation * 0.2}s;

        &.instant {
          animation-delay: 0s;
          animation-duration: ${(props) => props.fadeOutTextsAnimation * 1}s;
        }
      }

      &-subtitle {
        font-size: 3.5vmin;
        font-weight: 700;
        margin: 0;

        animation-delay: ${(props) => props.enterTitleAnimation * 0.2}s;
        animation-duration: ${(props) => props.enterTitleAnimation * 0.2}s;

        &.instant {
          animation-delay: 0s;
          animation-duration: ${(props) => props.fadeOutTextsAnimation * 1}s;
        }
      }

      &-place {
        font-size: 2.8vmin;
        margin-top: 1vmin;
        padding-bottom: 4vmin;
        animation-delay: ${(props) => props.enterTitleAnimation * 0.4}s;
        animation-duration: ${(props) => props.enterTitleAnimation * 0.2}s;

        &.instant {
          animation-delay: 0s;
          animation-duration: ${(props) => props.fadeOutTextsAnimation * 1}s;
        }
      }
    }

    @media (orientation: portrait) {
      z-index: 2;
    }
    .visible {
      visibility: visible !important;
    }
    .invisible {
      visibility: hidden;
    }
  }

  .content-measurement-text,
  .text {
    max-height: 60vmin;
    font-size: 3.5vmin;
    width: 100%;
    overflow: hidden;

    @media (orientation: portrait) {
      margin-bottom: 2vmin;
      max-height: none;
    }
  }

  .hidden-used-for-measurement {
    visibility: hidden;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .text-and-download-images {
    display: flex;

    @media (orientation: portrait) {
      max-height: 65vh;
    }

    .text {
      font-size: 3.5vmin;
      width: 100%;
      overflow: hidden;

      a {
        color: #fff;
      }

      ul {
        padding: revert;
        list-style-type: initial;

        & > li {
          list-style-type: initial;
        }
      }

      & > *:last-child {
        margin-bottom: 0;
      }
    }

    .download-app-images {
      height: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin-left: 2.5vmin;
      margin-top: 1vmin;

      align-self: end;

      @media (orientation: portrait) {
        justify-content: flex-end;
        margin-left: auto;
      }

      canvas {
        height: 13.4vmin !important;
        width: 13.4vmin !important;
        border: 2px solid white;
      }
    }

    @media (orientation: portrait) {
      flex-direction: column;
    }

    table[border='0'] {
      tr,
      td {
        border: none;
      }
    }

    tr {
      td {
        border: solid 0.2vmin #fff;
        padding-left: 2vmin;
      }
    }
  }

  .store-images {
    height: 16.5vmin;
    margin: 0 1vmin;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    img {
      width: 22vmin;
    }

    @media (orientation: portrait) {
      margin: 0 1vmin 0 0;
    }

    @media (orientation: portrait) {
      margin: 0 1vmin 0 0;
    }
  }

  .black-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: linear-gradient(
      60deg,
      rgba(1, 1, 1, 0.8) 12%,
      rgba(1, 1, 1, 0.7) 25%,
      rgba(1, 0, 1, 0.6) 34%,
      rgba(1, 1, 1, 0.5) 41%,
      rgba(1, 1, 1, 0.3) 51%,
      rgba(1, 1, 1, 0.2) 65%,
      rgba(1, 1, 1, 0.1) 80%,
      rgba(255, 255, 255, 0) 100%
    );
    transition: background-position ${(props) => props.enterContentAnimation * 1}s;
    background-size: 150% 100%;
    background-position: 75% 0;

    &.darker-overlay {
      background-position: 0 0;
    }

    animation-delay: ${(props) => props.fadeInContentAnimation * 1}s;
    animation-duration: ${(props) => props.enterTitleAnimation * 1}s;

    &.fading-out {
      animation-delay: 0s;
      animation-duration: ${(props) => props.fadeOutTextsAnimation * 1}s;
    }
  }

  *:not(.black-overlay) {
    z-index: 2;
  }
`;
const QrCodeContainer = styled_components_1.default.div `
  height: 16.4vmin;
  border: 1.5vmin solid #000000;
  border-radius: 1.2vmin;
`;
const ENTER_TITLE_ANIMATION_TIME = 1 * 1000;
const ENTER_CONTENT_ANIMATION_TIME = 1 * 1000;
const HIDE_CONTENT_ANIMATION_TIME = 1 * 1000;
const FADE_OUT_TEXTS = 1 * 1000;
const FINAL_TITLE_DISPLAY_TIME = 1 * 1000;
const TIME_UNTIL_SCROLL_STARTS = 5 * 1000;
const TIME_AFTER_SCROLL_STOPS = 5 * 1000;
const SCROLL_FREQUENCY = 50; // milisec, used to controll speed of scrolling,
const DetailPage = (props) => {
    const { content, openNextSlide, settings, timezone, setCurrentSlideDuration, venue, currentLocale } = props;
    const { speed, stopAnimationsInSlide } = settings;
    const [contentRefHeight, setContentRefHeight] = (0, react_1.useState)(0);
    const [availabilityState, setAvailabilityState] = (0, react_1.useState)(null);
    const [showBookingStatus, setShowBookingStatus] = (0, react_1.useState)(false);
    const { brand, venue: urlVenue } = (0, useUrlParams_1.useUrlParams)();
    const textRef = (0, react_1.useRef)(null);
    const measurementTextRef = (0, react_1.useRef)(null);
    const measurementContentRef = (0, react_1.useRef)(null);
    const enterTitleAnimationTimeout = (0, react_1.useRef)(null);
    const enterContentAnimationTimeout = (0, react_1.useRef)(null);
    const displayTimeTimeout = (0, react_1.useRef)(null);
    const timeUntilScrollStartsTimeout = (0, react_1.useRef)(null);
    const timeAfterScollStopsTimeout = (0, react_1.useRef)(null);
    const contentHideAnimationTimeout = (0, react_1.useRef)(null);
    const finalTitleDisplayTimeout = (0, react_1.useRef)(null);
    const fullScreenImageTimeout = (0, react_1.useRef)(null);
    const enterFadeInTimeout = (0, react_1.useRef)(null);
    const exitFadeOutTimeout = (0, react_1.useRef)(null);
    const scrollStartTime = (0, react_1.useRef)(null);
    const totalScrollDuration = (0, react_1.useRef)(null);
    const totalScrollAmount = (0, react_1.useRef)(null);
    const animationFrameRef = (0, react_1.useRef)(null);
    const isFullscreenItem = content.dsFullScreen;
    const clearAllTimeouts = () => {
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(enterTitleAnimationTimeout.current);
        clearTimeout(enterContentAnimationTimeout.current);
        clearTimeout(displayTimeTimeout.current);
        clearTimeout(timeUntilScrollStartsTimeout.current);
        clearTimeout(timeAfterScollStopsTimeout.current);
        clearTimeout(contentHideAnimationTimeout.current);
        clearTimeout(fullScreenImageTimeout.current);
        clearTimeout(finalTitleDisplayTimeout.current);
        clearTimeout(enterFadeInTimeout.current);
    };
    const handleNextSlide = () => {
        // console.log( "animations done, should go to next slide" );
        // console.log( "---------END SLIDE-------" );
        if (!settings.stopSlideShow) {
            openNextSlide();
        }
    };
    (0, react_1.useEffect)(() => {
        if (brand && urlVenue && content.contentId && content.bookable === true) {
            let isMounted = true;
            services_1.apiService.getAvailabilitiesForDS(content.locale, brand, urlVenue, [content.contentId]).then(availabilities => {
                if (isMounted && availabilities && availabilities.length > 0) {
                    setAvailabilityState(availabilities[0].availabilityState);
                    setTimeout(() => {
                        setShowBookingStatus(true);
                    }, 1000);
                }
            });
            return () => {
                isMounted = false;
            };
        }
    }, [content.locale, content.contentId, brand, urlVenue, content.bookable]);
    // sixth
    const fadeOutTexts = () => {
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('black-overlay')[0].classList.add('animate__fadeOut');
            document.getElementsByClassName('black-overlay')[0].classList.add('fading-out');
            document.getElementsByClassName('detail-page-title')[0].classList.add('instant');
            document.getElementsByClassName('detail-page-subtitle')[0].classList.add('instant');
            document.getElementsByClassName('detail-page-place')[0].classList.add('instant');
            document.getElementsByClassName('detail-page-title')[0].classList.add('animate__fadeOut');
            document.getElementsByClassName('detail-page-subtitle')[0].classList.add('animate__fadeOut');
            document.getElementsByClassName('detail-page-place')[0].classList.add('animate__fadeOut');
        }
        exitFadeOutTimeout.current = setTimeout(() => {
            handleNextSlide();
        }, FADE_OUT_TEXTS / speed);
    };
    // fifth
    const startFinalTitleDisplay = () => {
        // console.log( "displaying final title" );
        finalTitleDisplayTimeout.current = setTimeout(() => {
            fadeOutTexts();
        }, FINAL_TITLE_DISPLAY_TIME / speed);
    };
    // fourth
    const startContentHideAnimation = () => {
        // console.log( "hiding content" );
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('black-overlay')[0].classList.remove('darker-overlay');
            document.getElementsByClassName('texts')[0].classList.remove('top-animation');
            document.getElementsByClassName('text-and-download-images')[0].classList.add('is-hiding');
            document.getElementsByClassName('text-and-download-images')[0].classList.add('animate__fadeOut');
            const descriptionWrapper = document.getElementById('description-wrapper');
            // eslint-disable-next-line no-unused-expressions
            descriptionWrapper && descriptionWrapper.classList.add('hidden');
        }
        contentHideAnimationTimeout.current = setTimeout(() => {
            startFinalTitleDisplay();
        }, HIDE_CONTENT_ANIMATION_TIME / speed);
    };
    // scroll if needed
    const scrollOverflowingText = time => {
        if (!scrollStartTime.current) {
            scrollStartTime.current = time;
        }
        const runtime = time - scrollStartTime.current;
        const relativeProgress = runtime / totalScrollDuration.current;
        const newScrollTopValue = totalScrollAmount.current * Math.min(relativeProgress, 1);
        const hasNotReachedBottom = runtime < totalScrollDuration.current;
        textRef.current.scrollTop = newScrollTopValue;
        if (hasNotReachedBottom) {
            animationFrameRef.current = requestAnimationFrame(scrollOverflowingText);
        }
        else {
            cancelAnimationFrame(animationFrameRef.current);
            // console.log( "wait a bit before hiding content" );
            timeAfterScollStopsTimeout.current = setTimeout(() => {
                startContentHideAnimation();
            }, TIME_AFTER_SCROLL_STOPS / speed);
        }
    };
    // third
    const startContentScroll = () => {
        const textIsOverflowing = measurementTextRef.current && measurementTextRef.current.clientHeight < measurementTextRef.current.scrollHeight;
        if (measurementTextRef.current && textIsOverflowing) {
            // console.log( "waiting for scroll" );
            timeUntilScrollStartsTimeout.current = setTimeout(() => {
                // console.log( "scrolling" );
                animationFrameRef.current = requestAnimationFrame(scrollOverflowingText);
            }, TIME_UNTIL_SCROLL_STARTS);
        }
        else {
            // console.log( "wait for reading" );
            displayTimeTimeout.current = setTimeout(() => {
                startContentHideAnimation();
            }, settings.changeSlideInterval);
        }
    };
    // second
    const startContentEnterAnimation = () => {
        // console.log( "entering content" );
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('black-overlay')[0].classList.add('darker-overlay');
            document.getElementsByClassName('texts')[0].classList.remove('instant-transition');
            const descriptionWrapper = document.getElementById('description-wrapper');
            // eslint-disable-next-line no-unused-expressions
            descriptionWrapper && descriptionWrapper.classList.remove('hidden');
            document.getElementsByClassName('texts')[0].classList.add('top-animation');
        }
        enterContentAnimationTimeout.current = setTimeout(() => {
            startContentScroll();
        }, ENTER_CONTENT_ANIMATION_TIME / speed);
    };
    // first
    const startTitleEnterAnimation = () => {
        // console.log( "entering title" );
        if (!stopAnimationsInSlide) {
            document.getElementsByClassName('detail-page-title')[0].classList.add('animate__fadeInUp');
            document.getElementsByClassName('detail-page-title')[0].classList.add('visible');
            document.getElementsByClassName('detail-page-subtitle')[0].classList.add('animate__fadeInUp');
            document.getElementsByClassName('detail-page-subtitle')[0].classList.add('visible');
            document.getElementsByClassName('detail-page-place')[0].classList.add('animate__fadeInUp');
            document.getElementsByClassName('detail-page-place')[0].classList.add('visible');
            document.getElementsByClassName('text-and-download-images')[0].classList.add('visible');
            document.getElementsByClassName('used-for-display')[0].classList.add('animate__fadeInUp');
        }
        else {
            document.getElementsByClassName('black-overlay')[0].classList.add('darker-overlay');
        }
        enterTitleAnimationTimeout.current = setTimeout(() => {
            startContentEnterAnimation();
        }, ENTER_TITLE_ANIMATION_TIME / speed);
    };
    // zero
    const enterFadeInAnimation = () => {
        // console.log( "fade in all" );
        document.getElementsByClassName('detail-page-container')[0].classList.remove('hide');
        document.getElementsByClassName('black-overlay')[0].classList.add('animate__fadeIn');
        enterFadeInTimeout.current = setTimeout(() => {
            startTitleEnterAnimation();
        }, settings.fadeInContentTime);
    };
    (0, react_1.useEffect)(() => {
        clearAllTimeouts();
        const contentRef = measurementContentRef && measurementContentRef.current;
        const contentRefHeightMeasured = contentRef && contentRef.clientHeight;
        setContentRefHeight(contentRefHeightMeasured);
        const overallSlideDuration = settings.fadeInContentTime +
            ENTER_TITLE_ANIMATION_TIME / speed +
            ENTER_CONTENT_ANIMATION_TIME / speed +
            settings.changeSlideInterval +
            HIDE_CONTENT_ANIMATION_TIME / speed +
            FINAL_TITLE_DISPLAY_TIME / speed +
            FADE_OUT_TEXTS / speed;
        if (isFullscreenItem) {
            setCurrentSlideDuration(overallSlideDuration);
            fullScreenImageTimeout.current = setTimeout(() => {
                handleNextSlide();
            }, overallSlideDuration);
            return;
        }
        const textIsOverflowing = measurementTextRef.current && measurementTextRef.current.clientHeight < measurementTextRef.current.scrollHeight;
        const descriptionWrapper = document.getElementById('description-wrapper');
        // eslint-disable-next-line no-unused-expressions
        descriptionWrapper && descriptionWrapper.classList.remove('animate__fadeOut');
        if (measurementTextRef.current && textIsOverflowing) {
            const scrollFrequency = SCROLL_FREQUENCY / speed;
            const { scrollHeight, clientHeight } = measurementTextRef.current;
            const amountToScroll = scrollHeight - clientHeight;
            const scrollDuration = (scrollHeight - clientHeight) * scrollFrequency;
            totalScrollAmount.current = amountToScroll;
            totalScrollDuration.current = scrollDuration;
            const intendedSlideDuration = settings.fadeInContentTime +
                ENTER_TITLE_ANIMATION_TIME / speed +
                ENTER_CONTENT_ANIMATION_TIME / speed +
                TIME_UNTIL_SCROLL_STARTS / speed +
                scrollDuration +
                TIME_AFTER_SCROLL_STOPS / speed +
                HIDE_CONTENT_ANIMATION_TIME / speed +
                FINAL_TITLE_DISPLAY_TIME / speed +
                FADE_OUT_TEXTS / speed;
            // console.log( "set WITH scroll", overallSlideDuration );
            setCurrentSlideDuration(intendedSlideDuration);
        }
        else {
            // console.log( "set WITHOUT scroll", overallSlideDuration );
            setCurrentSlideDuration(overallSlideDuration);
        }
        enterFadeInAnimation();
    }, [content]);
    (0, react_1.useEffect)(() => () => {
        clearAllTimeouts();
    }, []);
    const locale = content.locale ? content.locale : currentLocale;
    const activityTime = renderActivityTime(content, locale, timezone);
    // without this class animations do not trigger
    const mainAnimationClass = stopAnimationsInSlide ? '' : 'animate__animated';
    const topAnimation = stopAnimationsInSlide ? 'top-animation' : '';
    const visibleClass = stopAnimationsInSlide ? 'visible' : 'invisible';
    // the code below is used to display the logo for certain brands
    let logoPath = '';
    switch (venue.brandSlug) {
        case 'tui-blue':
            logoPath = '/images/ds-logos/tui_blue_logo.svg';
            break;
        case 'tui-magic-life':
            logoPath = '/images/ds-logos/tui_magiclife_logo.svg';
            break;
        case 'robinson-club':
            logoPath = '/images/ds-logos/robinson_club_logo.svg';
            break;
        default:
            logoPath = '';
    }
    const hideAppDownloadContent = props.hideAppDownloads ? 'hide-app-downloads' : '';
    return (react_1.default.createElement(DetailPageContainer, { backgroundImages: {
            landscape: content.images[0] && content.images[0]['2:1'] && content.images[0]['2:1'].XXL,
            portrait: content.images[0] && content.images[0]['10:10'] && content.images[0]['10:10'].XXL,
        }, fadeInContentAnimation: settings.fadeInContentTime / 1000, className: `detail-page-container animate__animated animate__fadeIn hide ${hideAppDownloadContent} ${logoPath !== '' ? 'detail-page-container-with-logo' : ''}` },
        logoPath !== '' && (react_1.default.createElement(material_1.Box, { className: "detail-page-logo" },
            react_1.default.createElement("img", { src: `${logoPath}`, alt: "Brand Logo" }))),
        react_1.default.createElement(RegularPageContainer, { fadeInContentAnimation: settings.fadeInContentTime / 1000, enterTitleAnimation: ENTER_TITLE_ANIMATION_TIME / speed / 1000, enterContentAnimation: ENTER_CONTENT_ANIMATION_TIME / speed / 1000, hideContentAnimation: HIDE_CONTENT_ANIMATION_TIME / speed / 1000, fadeOutTextsAnimation: FADE_OUT_TEXTS / speed / 1000, contentRefHeight: contentRefHeight },
            react_1.default.createElement(material_1.Box, { className: `texts ${topAnimation} instant-transition` },
                react_1.default.createElement(material_1.Typography, { variant: "h1", className: `${visibleClass} detail-page-title title ${mainAnimationClass}` },
                    ' ',
                    content.title ? content.title : '',
                    ' '),
                react_1.default.createElement(material_1.Typography, { variant: "h3", className: `${visibleClass} ${mainAnimationClass} detail-page-subtitle title` },
                    ' ',
                    activityTime,
                    ' '),
                react_1.default.createElement(material_1.Typography, { component: "div", className: `${visibleClass} ${mainAnimationClass}  detail-page-place title` },
                    ' ',
                    content.placeName ? content.placeName : '',
                    ' ',
                    availabilityState && (react_1.default.createElement(material_1.Box, null,
                        react_1.default.createElement(BookingStatus_1.default, { key: locale, availabilityState: availabilityState, size: 1, currentLocale: locale })))),
                react_1.default.createElement(material_1.Box, { className: `${visibleClass} ${mainAnimationClass} text-and-download-images used-for-display`, id: "description-wrapper" },
                    react_1.default.createElement(material_1.Box, { className: "text", ref: textRef, dangerouslySetInnerHTML: {
                            __html: content.text || null,
                        } }),
                    react_1.default.createElement(material_1.Box, { className: "download-app-images" },
                        !props.appStoreBannersDisabled && (react_1.default.createElement(material_1.Box, { className: "store-images" },
                            react_1.default.createElement("img", { src: "/images/download_banner/google-play.svg", alt: "Google Play" }),
                            react_1.default.createElement("img", { src: "/images/download_banner/app-store.svg", alt: "App Store" }))),
                        content.deeplink && (react_1.default.createElement(QrCodeContainer, null,
                            react_1.default.createElement(qrcode_react_1.default, { value: content.deeplink, className: "qr-code" }))))),
                react_1.default.createElement(material_1.Box, { className: "text-and-download-images hidden-used-for-measurement", ref: measurementContentRef },
                    react_1.default.createElement(material_1.Box, { className: "content-measurement-text", ref: measurementTextRef, dangerouslySetInnerHTML: {
                            __html: content.text || null,
                        } }),
                    react_1.default.createElement(material_1.Box, { className: "download-app-images" },
                        !props.appStoreBannersDisabled && (react_1.default.createElement(material_1.Box, { className: "store-images" },
                            react_1.default.createElement("img", { src: "/images/download_banner/google-play.svg", alt: "Google Play" }),
                            react_1.default.createElement("img", { src: "/images/download_banner/app-store.svg", alt: "App Store" }))),
                        content.deeplink && react_1.default.createElement(qrcode_react_1.default, { value: content.deeplink, className: "qr-code" })))),
            react_1.default.createElement(material_1.Box, { className: "black-overlay animate__animated" }))));
};
function renderActivityTime(content, locale, timezone) {
    if (!content.start) {
        return null;
    }
    const dateOptions = {
        day: 'numeric',
        weekday: 'long',
        month: 'long',
    };
    const datePart = helpers_1.Helpers.getDateFromStringDependingLocale(content.start, locale, timezone, true, dateOptions).date;
    const startTime = helpers_1.Helpers.getHourFromDate(content.start, timezone, locale);
    const endTime = helpers_1.Helpers.getHourFromDate(content.end, timezone, locale);
    const isGermanLocale = locale === null || locale === void 0 ? void 0 : locale.toLowerCase().startsWith('de');
    const endTimeWithSuffix = isGermanLocale ? `${endTime} Uhr` : endTime;
    const startTimeWithSuffix = isGermanLocale ? `${startTime} Uhr` : startTime;
    if (content.showStartTime && content.showEndTime) {
        return `${datePart} • ${startTime} - ${endTimeWithSuffix}`;
    }
    if (content.showStartTime && !content.showEndTime) {
        return `${datePart} • ${startTimeWithSuffix}`;
    }
    return datePart;
}
const mapStoreToProps = store => ({
    appStoreBannersDisabled: store.getValue('appStoreBannersDisabled'),
    hideAppDownloads: store.getValue('hideAppDownloads'),
    timezone: store.getValue('timezone'),
    venue: store.getValue('venue'),
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(DetailPage);
